export const CF_SPACE_ID_SHARED =
  process.env.CF_SPACE_ID_SHARED ?? 'ewp1r825fxg0';

export const CF_SPACE_ID_WEBSITE =
  process.env.CF_SPACE_ID_WEBSITE ?? 'ixftmapd0r12';

export const CF_SPACE_ID_ACCOUNT =
  process.env.CF_SPACE_ID_ACCOUNT ?? 'vkiwdqapdqy1';

export const CF_SPACE_ID_DASHBOARD =
  process.env.CF_SPACE_ID_DASHBOARD ?? 'vmhwl5safgdj';

export const CF_SPACE_ID_PDM = process.env.CF_SPACE_ID_PDM ?? 'nl4z0p8934li';

export const CF_SPACE_ID_LIGHTHOUSE =
  process.env.CF_SPACE_ID_LIGHTHOUSE ?? 'tii6xmoiynio';

export const CF_SPACE_ID_CORPORATE =
  process.env.CF_SPACE_ID_CORPORATE ?? 'ug20hbnqdhw9';

export const CF_ENV_SHARED = process.env.CF_ENV_SHARED ?? 'master';
export const CF_ENV_WEBSITE = process.env.CF_ENV_WEBSITE ?? 'master';
export const CF_ENV_ACCOUNT = process.env.CF_ENV_ACCOUNT ?? 'master';
export const CF_ENV_DASHBOARD = process.env.CF_ENV_DASHBOARD ?? 'master';
export const CF_ENV_PDM = process.env.CF_ENV_PDM ?? 'master';
export const CF_ENV_LIGHTHOUSE = process.env.CF_ENV_LIGHTHOUSE ?? 'master';
export const CF_ENV_CORPORATE = process.env.CF_ENV_CORPORATE ?? 'master';

export const CF_DELIVERY_TOKEN_SHARED =
  process.env.CF_DELIVERY_TOKEN_SHARED ??
  'mY6lkYFz7SRvq66ypleqKrT6XtR26AtDdg_rOMv70U0';

export const CF_DELIVERY_TOKEN_WEBSITE =
  process.env.CF_DELIVERY_TOKEN_WEBSITE ??
  'iBDP9CeZFUrgJnDL2I2_OwdylSLwHKzCin5n_M6K-IU';

export const CF_DELIVERY_TOKEN_ACCOUNT =
  process.env.CF_DELIVERY_TOKEN_ACCOUNT ??
  'I-5P098qhXDfrfBJVbTazbEXrzBViWIjcI1-r1EkAtE';

export const CF_DELIVERY_TOKEN_DASHBOARD =
  process.env.CF_DELIVERY_TOKEN_DASHBOARD ??
  'vuxjFZlFnc7-oj4fiQvZfQ0RGqp0pKmUP3mH9_pyEyo';

export const CF_DELIVERY_TOKEN_PDM =
  process.env.CF_DELIVERY_TOKEN_PDM ??
  'jTkMC_Q-4lwWfXE9Cs1jQ7HALec6ha6LirHGt3ubtp0';

export const CF_DELIVERY_TOKEN_LIGHTHOUSE =
  process.env.CF_DELIVERY_TOKEN_LIGHTHOUSE ??
  'NX14tnlR1sQMAss94wOYXX2REO8hkry8ds4AuSHIpY8';

export const CF_DELIVERY_TOKEN_CORPORATE =
  process.env.CF_DELIVERY_TOKEN_CORPORATE ??
  'Xst1qR4p8WRtmS7TdWeqhdzpDVnQhy1XVKxAn8X4mZQ';

export const CF_PREVIEW_TOKEN_SHARED =
  process.env.CF_PREVIEW_TOKEN_SHARED ??
  'RNITASNPH_8oXssl74RWpJOxeZXlgWlP6dugbb8ETSU';

export const CF_PREVIEW_TOKEN_WEBSITE =
  process.env.CF_PREVIEW_TOKEN_WEBSITE ??
  'LLEpLjJChKb4IfA-Dslt1iCVOjpWwRW8y0I1eUKP41c';

export const CF_PREVIEW_TOKEN_ACCOUNT =
  process.env.CF_PREVIEW_TOKEN_ACCOUNT ??
  'saa6fmH0vCdi6D23nw228p0xqH4QQIFN63pKshgqfkY';

export const CF_PREVIEW_TOKEN_DASHBOARD =
  process.env.CF_PREVIEW_TOKEN_DASHBOARD ??
  'xB4fSACdeIFOy10XSBQbrELHitoqb2T-5U7Db_gvPws';

export const CF_PREVIEW_TOKEN_PDM =
  process.env.CF_PREVIEW_TOKEN_PDM ??
  'YCTfRfYut-MS7mnTA4hFIUx4tEZygqANuF-A_ODnOgE';

export const CF_PREVIEW_TOKEN_LIGHTHOUSE =
  process.env.CF_PREVIEW_TOKEN_LIGHTHOUSE ??
  'Lm3lHTQPeGW4_mOwkbNGUl4J43idnpNGr7KnLDw3AMo';

export const CF_PREVIEW_TOKEN_CORPORATE =
  process.env.CF_PREVIEW_TOKEN_CORPORATE ??
  'M4Ru10WZ50IXDxD1lmPvCIPHsMD7KgrM8iO7GrbbXVg';
